const modulo_filtros = {
    strict: false,

    state: {
        filtros: {},
    },

    getters: {
        getfiltros: (state) => state.filtros,
    },

    mutations: {
        save_filtros_seguimiento: (state, filtros) => {
            state.filtros["seguimientos"] = filtros;
        },
        saver_filtros_potencial: (state, filtros) => {
            state.filtros["potencial"] = filtros;
        },
        save_filtro_presupuesto: (state, filtros) => {
            state.filtros["presupuesto"] = filtros;
        },
        save_filtro_peticiones: (state, filtros) => {
            state.filtros["peticiones"] = filtros;
        },
    },

    actions: {
        saveFiltrosSeguimiento: (context, filtros) => {
            context.commit("save_filtros_seguimiento", filtros);
        },
        saveFiltrosPotencial: (context, filtros) => {
            context.commit("saver_filtros_potencial", filtros);
        },
        saveFiltrosPresupuesto: (context, filtros) => {
            context.commit("save_filtro_presupuesto", filtros);
        },
        saveFiltrosPeticiones: (context, filtros) => {
            context.commit("save_filtro_peticiones", filtros);
        },
        
    },
};

export default modulo_filtros;
